var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:_vm.padded && 'padded'},[(!_vm.isLoading)?_c('md-checkbox',{attrs:{"value":!_vm.isChecked},on:{"change":function($event){return _vm.onChange()}}}):_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-diameter":18}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }